import {
  ErrorResponseCodeType,
  EndPointsNames,
  ApiCredentialsType,
} from '_core/types';
import { setEntityName } from '_core/util/object';

export const API_DOMAIN: EndPointsNames = 'ApiAccount';
export const ENDPOINT_API_PATH = 'v1/members/change/status';
export const ENTITY_NAME = setEntityName(ENDPOINT_API_PATH);
const API_CREDENTIALS_TYPE: ApiCredentialsType = 'TOKEN_AUTH_USER';
const URL_POSTMAN =
  'https://smiles-sa.postman.co/workspace/Conta~1aa3f7db-730f-4a9e-8904-3201cc3d9669/collection/12684301-64467b55-913d-4f0f-9bd0-52507a8f6116?ctx=documentation';

export const CODE_ERRORS: ErrorResponseCodeType[] = [
  {
    code: '1',
    bussinessErrorVariant: 'errorService',
    message: 'Ocorreu um erro inesperado (favor contatar a Smiles)',
  },
  {
    code: '2',
    bussinessErrorVariant: 'userNotFound',
    message:
      'Não foi possível acessar sua conta. Para maiores informações, entre em contato com a central de atendimento Smiles.',
  },
  {
    code: '11',
    bussinessErrorVariant: 'wrongParams',
    message: 'Parametros de entrada inválido',
  },
];

export default {
  API_DOMAIN,
  ENDPOINT_API_PATH,
  API_CREDENTIALS_TYPE,
  URL_POSTMAN,
  CODE_ERRORS,
  ENTITY_NAME,
};
